import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PrivateRoute from './components/PrivateRoute';

// Import components
import Homepage from './components/Homepage';
import ComingSoon from './components/ComingSoon';
import ProfilePage from "./components/ProfilePage";
import OrderPage from "./components/OrderPage";
import LoginPage from "./components/LoginPage";
import RegisterPage from "./components/RegisterPage";
import AdminDashboard from "./components/AdminDashboard";
import EditMemorialPage from "./components/EditMemorialPage";
import PublicMemorialPage from "./components/PublicMemorialPage";
import TermsPage from "./components/TermsPage";
import PrivacyPage from "./components/PrivacyPage";

function App() {
    return (
        <Router>
            <Routes>
                {/* Public Routes */}
                <Route path="/" element={<Homepage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/coming-soon" element={<ComingSoon />} />
                <Route path="/terms" element={< TermsPage/>} />
                <Route path="/privacy" element={< PrivacyPage/>} />


                {/* Protected Routes - Require Authentication */}
                <Route
                    path="/profile"
                    element={<PrivateRoute element={<ProfilePage />} />}
                />
                <Route
                    path="/order"
                    element={<PrivateRoute element={<OrderPage />} />}
                />
                <Route
                    path="/edit-memorial/:qrId"
                    element={<PrivateRoute element={<EditMemorialPage />} />}
                />

                <Route path="/q/:code" element={<PublicMemorialPage />} />


                {/* Admin Only Routes */}
                <Route
                    path="/admin"
                    element={<PrivateRoute element={<AdminDashboard />} adminOnly={true} />}
                />
            </Routes>
        </Router>
    );
}

export default App;
